module.exports = __webpack_public_path__ + "img/saalogo.2723f896.png";